// extracted by mini-css-extract-plugin
export var createdDate = "_ms-1";
export var divider = "_ms-2";
export var headerDivider = "_ms-3";
export var messagesCard = "_ms-0";
export var messagesContainer = "_ms-7";
export var messagesContainerWrapper = "_ms-4";
export var pointerCapturingButtonBoxes = "_ms-a";
export var showLeftPanelButton = "_ms-9";
export var showMoreButton = "_ms-c";
export var showMoreButtonContainer = "_ms-b";
export var summaryTitle = "_ms-6";
export var systemMessageCardWrapper = "_ms-d";
export var topButtons = "_ms-8";
export var withPadding = "_ms-5";